// // import React, { useState } from 'react';
// // import { HexColorPicker } from "react-colorful";

// // const ColorPickerInput = ({ color, onChange }) => {
// //   const [isPickerVisible, setPickerVisible] = useState(false);

// //   return (
// //     <div>
// //       <input 
// //         type="text" 
// //         value={color} 
// //         readOnly 
// //         onClick={() => setPickerVisible(true)} 
// //       />
// //       {isPickerVisible && (
// //         <HexColorPicker color={color} onChange={onChange} onBlur={() => setPickerVisible(false)} />
// //       )}
// //     </div>
// //   );
// // };

// // export default ColorPickerInput;

// import React, { useState, useEffect, useRef } from 'react';
// import { HexColorPicker } from "react-colorful";

// const ColorPickerInput = ({ color, onChange }) => {
//   const [isPickerVisible, setPickerVisible] = useState(false);
//   const colorPickerRef = useRef(null);

//   const handleClickOutside = (event) => {
//     if (colorPickerRef.current && !colorPickerRef.current.contains(event.target)) {
//       setPickerVisible(false);
//     }
//   };

//   useEffect(() => {
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   return (
//     <div ref={colorPickerRef} className='color-picker-wrapper'>
//       <input 
//         type="text" 
//         value={color} 
//         onClick={() => setPickerVisible(true)} 
//       />
//       {isPickerVisible && (
//         <HexColorPicker color={color} onChange={onChange} />
//       )}
//     </div>
//   );
// };

// export default ColorPickerInput;


import React, { useState, useEffect, useRef } from 'react';
import { HexColorPicker } from "react-colorful";

const ColorPickerInput = ({ color: propColor, onChange }) => {
  const [color, setColor] = useState(propColor);
  const [isPickerVisible, setPickerVisible] = useState(false);
  const colorPickerRef = useRef(null);

  const handleClickOutside = (event) => {
    if (colorPickerRef.current && !colorPickerRef.current.contains(event.target)) {
      setPickerVisible(false);
    }
  };

  const handleInputChange = (event) => {
    const newColor = event.target.value;
    setColor(newColor);
    onChange(newColor);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={colorPickerRef} className='color-picker-wrapper'>
      <input 
        type="text" 
        value={color} 
        onChange={handleInputChange}
        onClick={() => setPickerVisible(true)} 
      />
      {isPickerVisible && (
        <HexColorPicker color={color} onChange={(newColor) => { setColor(newColor); onChange(newColor); }} />
      )}
    </div>
  );
};

export default ColorPickerInput;
